<template>
  <div class="">
    <div class="head-title">系统管理员</div>
    <el-collapse style="margin-bottom: 2rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1.
            添加不同部门子管理员账号，设置相关角色，总账户可删除、开启、编辑所有子账户信息。
          </p>
          <p>2、监管部门是与企业微信管理后台通讯录中的负责部门同步</p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="">
      <div class="mMain">
        <nav class="navbar" style="margin-bottom: 2rem">
          <div class="nav-l">
            <div style="margin-right: 24px">
              <el-button icon="el-icon-plus" type="primary" @click="(onSubmit = true), rout()">添加管理员</el-button>
            </div>
          </div>
          <div class="nav-r" style="display: flex">
            <div style="margin-right: 24px">
              <el-select clearable v-model="value" placeholder="请选择状态" @change="onSubmiton">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div style="margin-right: 24px">
              <el-input clearable v-model="czphone" style="width: 22rem; margin: 0 2rem 0 2rem"
                prefix-icon="el-icon-search" placeholder="请输入手机号搜索" @change="onSubmiton">
              </el-input>
              <el-button slot="append" type="primary" @click="onSubmiton">搜索</el-button>
            </div>
          </div>
        </nav>
        <el-table border :data="tableData.data" v-loading="tableLoading" style="width: 100%">
          <el-table-column prop="phone" label="手机号（登录账号）" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="position" label="职位" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="关联账户" width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="role_name" label="角色名称" width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="department_id_name" label="监管部门" width="270">
            <template slot-scope="scope">
              <!-- <div> -->
              <el-popover placement="left" trigger="hover">
                <template>
                  <div class="set-popper" v-html="scope.row.department_id_name_array"></div>
                </template>
                <div slot="reference" class="set-content">
                  <el-tag size="mini" style="margin: 2px" v-for="(i, index) in scope.row.department_id_name_array"
                    :key="index">{{ i }}</el-tag>
                </div>
              </el-popover>
              <!-- </div> -->
            </template>
          </el-table-column>
          <el-table-column prop="if_leader" label="部门负责人" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.if_leader == 1">是</div>
              <div v-else>否</div>
            </template>
          </el-table-column>
          <el-table-column prop="is_deny" label="是否可用" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_deny" :active-value="1" :inactive-value="2"
                :disabled="scope.row.role_id == 0" @change="
                  toggleStatus(
                    scope.row.is_deny,
                    scope.row.id,
                    scope.row.userid
                  )
                "></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="addtime" label="添加时间" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column fixed="right" label="操作"   width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="
                (dialogVisible = true),
                bj(
                  scope.row.id,
                  scope.row.phone,
                  scope.row.role_id,
                  scope.row.department_id,
                  scope.row.role_id,
                  scope.row.position,
                  scope.row.name,
                  scope.row.userid,
                  scope.row,
                  scope.row.password,
                  scope.row.role_name
                )
              ">
                编辑
              </el-button>
              <el-button :disabled="scope.row.role_id == 0" size="mini" type="text" @click="dele(scope.row.id)" style="color:#f00000 !important">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination :total="tableData.total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
            :page-sizes="[10, 20, 50, 100]" :auto-scroll="false" @pagination="handleCurrentChange" />
        </div>
      </div>
      <el-dialog title="添加管理员" center :visible.sync="onSubmit" width="40%">
        <el-form :rules="rules" ref="form" :model="AddAdministrator" label-width="18rem">
          <el-form-item label="关联账户" prop="zhanghu">
            <!-- <el-select
                style="min-width: 24rem"
                v-model="AddAdministrator.zhanghu"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="请搜索选择关联账户"
                :remote-method="remoteMethod"
                :loading="loading"
                @focus="getAccountList()"
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            <el-input clearable v-model="AddAdministrator.zhanghu" style="width: 16rem; margin-right: 2rem"
              @focus="getAccountList()"></el-input>
            <el-button class="addBtn" icon="el-icon-plus" @click="onAdd">前往修改</el-button>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input clearable v-model="AddAdministrator.phone" placeholder="登录账号"></el-input>
          </el-form-item>
          <!-- <el-form-item label="账户">
            <el-input clearable v-model="AddAdministrator.account"></el-input>
          </el-form-item> -->
          <el-form-item label="密码" prop="password">
            <el-input clearable v-model="AddAdministrator.password" show-password></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="addpassword">
            <el-input clearable type="password" autocomplete="off" v-model="AddAdministrator.addpassword" show-password>{{
              AddAdministrator.addpassword }}</el-input>
          </el-form-item>
          <el-form-item label="选择角色" prop="juese">
            <el-select clearable v-model="valu" placeholder="请选择">
              <el-option v-for="(item, index) in rout_list" :value="item.id" :key="index"
                :label="item.role_name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职位">
            <el-input clearable v-model="AddAdministrator.position"></el-input>
          </el-form-item>
          <!-- <el-form-item label="部门">
              <el-button
                @click="(dialogVisiblee = true), one()"
                size="small"
                style="color: #2890dd"
                >选择部门</el-button
              >
              <div v-if="CheckedNodes.length">
                <el-tag
                  style="margin-right: 12px"
                  effect="plain"
                  type="info"
                  v-for="(item, idx) of CheckedNodes"
                  :key="idx"
                  >{{ item }}</el-tag
                >
              </div>
            </el-form-item> -->

          <!-- <el-form-item label="部门负责人">
              <el-radio-group v-model="AddAdministrator.resource">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSubmit = false">取 消</el-button>
          <el-button type="primary" @click="numoo()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="修改" center :visible.sync="dialogVisible" width="30%">
        <el-form :model="modification" label-width="12rem">
          <el-form-item label="关联账号" prop="zhanghu">
            <el-input clearable v-model="zhanghu" style="width: 16rem; margin-right: 2rem"></el-input>
            <el-button class="addBtn" icon="el-icon-plus" @click="onAdd">前往修改</el-button>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input clearable v-model="modification.phone" placeholder="登录账号"></el-input>
          </el-form-item>
          <!-- <el-form-item label="账户">
            <el-input clearable v-model="modification.account"></el-input>
          </el-form-item> -->
          <el-form-item label="密码">
            <el-input clearable v-model="modification.password" show-password>{{
              modification.password
            }}</el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input clearable v-model="modification.addpassword" show-password>{{ modification.addpassword }}</el-input>
          </el-form-item>
          <!-- <div v-if="modification.role_id">
              <el-form-item label="选择角色" prop="juese">
                <el-select clearable v-model="modification.role_id" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in rout_list"
                    :value="item.id"
                    :key="index"
                    :label="item.role_name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div> -->
          <!-- role_id=0 为企业超管 -->
          <el-form-item label="选择角色" prop="juese" v-if="modification.role_id == 0">
            <el-input clearable v-model="modification.role_name" :disabled="modification.role_id == 0"></el-input>
          </el-form-item>
          <el-form-item label="选择角色" prop="juese" v-else>
            <el-select clearable v-model="modification.role_id" placeholder="请选择">
              <el-option v-for="(item, index) in rout_list" :value="item.id" :key="index"
                :label="item.role_name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职位">
            <el-input clearable v-model="modification.position">{{
              modification.position
            }}</el-input>
          </el-form-item>
          <!-- <el-form-item label="部门修改">
              <el-tag
                style="margin-right: 12px; color: #2890dd"
                type="info"
                effect="plain"
                @click="(dialogVisibleo = true), oned()"
                >部门列表</el-tag
              >
              <div v-if="CheckedNodes.length">
                <el-tag
                  size="mini"
                  style="margin: 2px"
                  v-for="(item, idx) of CheckedNodes"
                  :key="idx"
                  >{{ item }}</el-tag
                >
              </div>
            </el-form-item> -->
          <!-- <el-form-item label="部门负责人">
              <el-radio-group v-model="modification.resource">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="vak()">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="部门选择" center :visible.sync="dialogVisiblee" width="30%">
        <el-tree :data="legeList" show-checkbox default-expand-all node-key="id" ref="tree" :default-checked-keys="duihao"
          highlight-current :props="defaultProps"></el-tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblee = false">取 消</el-button>
          <el-button type="primary" @click="(dialogVisiblee = false), sbom()">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="修改部门" center :visible.sync="dialogVisibleo" width="30%">
        <el-tree :data="legeListon" show-checkbox default-expand-all node-key="id" ref="tree"
          :default-checked-keys="xuanran" highlight-current :props="defaultProps"></el-tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleo = false">取 消</el-button>
          <el-button type="primary" @click="(dialogVisibleo = false), sbomo()">确 定</el-button>
        </span>
      </el-dialog>
      <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import md5 from "js-md5";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';

export default {
  components: {
    Pagination,
    rightPeople
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("确认密码不能为空"));
      } else if (value !== this.AddAdministrator.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      timeout: null,
      tableData: {
        total: 0,
        data: [],
      }, //页面获取的数据
      czphone: "", //筛选手机号
      options: [
        {
          //筛选是否可用
          value: "1",
          label: "可用",
        },
        {
          value: "2",
          label: "禁用",
        },
      ],
      value: "", //筛选最终的id
      onSubmit: false, //添加管理员弹窗是否打开
      AddAdministrator: {
        //添加管理员账号密码用户
        account: "",
        password: "",
        addpassword: "",
        phone: "",
        position: "普通用户",
        resource: "0",
        zhanghu: "",
        zhanghuId: "",
      },
      rout_list: [], //添加管理员获取角色信息
      valu: "", //添加管理员角色value 值
      dialogVisible: false, //修改管理员
      valuer: "",
      modification: {
        password: "******",
        account: "",
        phone: "",
        id: "",
        role_id: "",
        weixin: "",
        position: "",
        userid: "",
        resource: 0,
        psd: "",
      },
      dialogVisiblee: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
      duihao: [],
      legeList: [], //分配权限
      nlist: [],
      dialogVisibleo: false, //修改部门权限
      defaultPropsd: {
        children: "children",
        label: "label",
      },
      modificationid: "",
      xuanran: [], //渲染修改的按钮
      legeListon: [], //分配权限
      nlistd: [],
      valullo: [],
      zhanghu: "",
      userid_name: "",
      rules: {
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { min: 11, max: 30, message: "手机格式不正确", trigger: "blur" },
        ],
        password: [
          {
            required: true,
            min: 6,
            message: "密码不能为空",
            trigger: "blur",
          },
        ],
        addpassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
        juese: [{ required: true, message: "角色不能为空", trigger: "blur" }],
        zhanghu: [
          {
            required: true,
            message: "账户不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      CheckedNodes: [],
      dbLabels: [],
      listQuery: {
        page: 1,
        limit: 20,
      },
      loading: false,
      accountList: [],
      userid: "",
      roleName: "",
      module: "",
      checkbox: false,
      tableLoading: true,
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
    this.rout();
  },
  methods: {
    async getAccountList(q = "") {
      const { data: res } = await this.axios({
        url: "/home/Admins/getWxUser",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          name: q,
        }),
      });
      this.accountList = res.data.map((item) => {
        return { value: `${item.userid}`, label: `${item.name}` };
      });
    },
    async remoteMethod(query) {
      this.loading = true;
      const accountList = await this.getAccountList(query);
      this.loading = false;
    },
    // querySearchAsync(queryString, cb) {
    //   var valullo = this.valullo;
    //   var results = queryString
    //     ? valullo.filter(this.createStateFilter(queryString))
    //     : valullo;

    //   clearTimeout(this.timeout);
    //   this.timeout = setTimeout(() => {
    //     cb(results);
    //   });
    // },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    onAdd() {
      this.module = "getAddressBook";
      this.checkbox = false;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      switch (this.module) {
        case "getClientBaseListGroupSop":
          this.chat = person;
          const chatid = this.chat.map((i) => {
            return i.chat_id;
          });
          this.form.chat_id = String(chatid);
          break;
        case "getAddressBook":
          this.zhanghu = person.name;
          this.AddAdministrator.zhanghu = person.name;
          this.AddAdministrator.zhanghuId = String(person.userid);
          break;
        default:
          break;
      }
    },
    toggleStatus(e, d, u) {
      this.yeshu = 1;
      if (e == 1) {
        this.axios
          .post(
            "/home/admins/editSessionUser",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              id: d,
              is_deny: 1,
              userid: u,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
          })
          .catch(function (err) { });
      } else if (e == 2) {
        this.axios
          .post(
            "/home/admins/editSessionUser",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              id: d,
              is_deny: 2,
              userid: u,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
          })
          .catch(function (err) { });
      }
    },
    renderDepartment(CheckedNodes) {
      const that = this;
      this.axios
        .post(
          "/home/Admins/getDepartmentNameById",
          qs.stringify({
            account_id: this.tooken.account_id,
            department_id: CheckedNodes,
            usertoken: this.tooken.usertoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.CheckedNodes = res.data.data;
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) { });
    },
    sbom() {
      let nodeList = Array.from(new Set([...this.$refs.tree.getCheckedKeys()]));
      const CheckedNodes = this.$refs.tree.getCheckedNodes(true, false);

      this.renderDepartment(CheckedNodes);
      this.duihao = nodeList;
      this.nlist = nodeList;
    },
    async sbomo() {
      this.CheckedNodes = []; //清空上次选择数据
      let nodeList = Array.from(new Set([...this.$refs.tree.getCheckedKeys()]));
      const CheckedNodes = this.$refs.tree.getCheckedNodes(true, false);

      this.renderDepartment(CheckedNodes);

      // console.log(CheckedNodes);
      // const legeListon = this.legeListon;
      // const dbLabels = this.getDbLabel(legeListon);
      // console.log(dbLabels);
      // if (CheckedNodes.length) {
      //   this.CheckedNodes = CheckedNodes.map((i) => i.label);
      // }
      // console.log(CheckedNodes);
      // this.getDepartmentName(CheckedNodes); //暂时只查询到部门级别标签，未找到父子标签合并查询更合理的方法，后期再进行优化

      this.xuanran = nodeList;
      let nodes = (this.nlistd = nodeList);
    },
    getDbLabel(labels) {
      for (const iterator of labels) {
        this.dbLabels.push({
          id: iterator.id,
          label: iterator.label,
        });
        if (iterator.children) {
          this.getDbLabel(iterator.children);
        }
      }
    },
    getDepartmentName2(data, parentID) { },
    // @ checks: 需要传入数组（必传）
    // @ parentLabel：递归需要使用的父标签，可不传
    // 暂时禁用此方法，后期再进行优化
    getDepartmentName(checks, parentID) {
      for (var i = 0; i < checks.length; i++) {
        if (parentId) {
          // 有子元素时，当前的父元素标签+子元素标签
          const label = `${parentId}/${checks[i]["label"]}`;
          this.CheckedNodes.push(label);
        } else {
          // 无子元素
          this.CheckedNodes.push(checks[i]["label"]);
        }

        if (checks[i]["children"]) {
          // 有子元素时应当删除当前父元素标签，合并入子元素标签
          this.CheckedNodes.pop();
          // 获取当前级别的标签
          let t = checks[i].label;
          if (parentId) {
            // 有父标签加上当前父标签，再次递归。
            // 具体效果：["技术部/前端组/前端开发/一组", "技术部/前端组/前端开发/二组", "技术部/UI组", "技术部/后端开发", "人事部/一组", "人事部/二组"]
            t = `${parentId}/${checks[i].label}`;
          }
          this.getDepartmentName(checks[i]["children"], t);
        }
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    //获取页面数据
    userTable() {
      this.axios
        .post(
          "/home/admins/getSessionUser",
          qs.stringify({
            parent_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          if (res.status == 200) {
            const resont = res.data.data.data;
            const uid = resont.map((res) => {
              return res.userid;
            });
            const role = resont.map((res) => {
              return res.role_name;
            });
            this.userid = uid;
            this.roleName = role;
          }
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          res.data.data.data.forEach((i) => {
            const isTagEmpty = i.department_id_name.includes("暂无");
            i.isTagEmpty = isTagEmpty;
            if (!isTagEmpty) {
              i.department_id_name = i.department_id_name.split(",");
            }
          });
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    //筛选
    onSubmiton() {
      this.axios
        .post(
          "/home/admins/getSessionUser",
          qs.stringify({
            parent_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.czphone,
            is_deny: this.value,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          res.data.data.data.forEach((i) => {
            const isTagEmpty = i.department_id_name.includes("暂无");
            i.isTagEmpty = isTagEmpty;
            if (!isTagEmpty) {
              i.department_id_name = i.department_id_name.split(",");
            }
          });
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    clearAdmin() {
      this.AddAdministrator.account = "";
      this.AddAdministrator.password = "";
      this.AddAdministrator.addpassword = "";
      this.AddAdministrator.phone = "";
      this.AddAdministrator.position = "普通用户";
      this.AddAdministrator.resource = "0";
      this.AddAdministrator.zhanghu = "";
      this.AddAdministrator.zhanghuId = "";
      this.valu = "";
    },
    // 点击添加获取角色列表
    rout() {
      this.CheckedNodes = [];
      this.clearAdmin();
      this.axios
        .post(
          "/home/role/getSessionRoleLists",
          qs.stringify({
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.rout_list = res.data.data;
        })
        .catch(function (err) { });
      this.axios
        .post(
          "/home/Admins/getWxUser",
          qs.stringify({
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.valullo = res.data.data;
          this.valullo.forEach((item) => {
            item.value = item.name;
          });
        })
        .catch(function (err) { });
    },
    // 添加系统管理员
    numoo() {
      if (this.AddAdministrator.zhanghu === "") {
        this.$message({
          type: "error",
          message: "请选择关联账户",
        });
        return;
      }
      if (this.AddAdministrator.phone === "") {
        this.$message({
          type: "error",
          message: "请输入登录账号",
        });
        return;
      }
      if (this.AddAdministrator.password === "") {
        this.$message({
          type: "error",
          message: "请输入密码",
        });
        return;
      }
      if (this.AddAdministrator.addpassword === "") {
        this.$message({
          type: "error",
          message: "请输入确认密码",
        });
        return;
      }
      if (
        this.AddAdministrator.addpassword !== this.AddAdministrator.password
      ) {
        this.$message({
          type: "error",
          message: "两次输入密码不一致!",
        });
        return;
      }
      if (this.valu === "") {
        this.$message({
          type: "error",
          message: "请选择角色"
        });
        return;
      }
      
      this.axios
        .post(
          "/home/admins/addSessionUser",
          qs.stringify({
            phone: this.AddAdministrator.phone,
            parent_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            account: this.AddAdministrator.account,
            password: this.$md5(this.AddAdministrator.password),
            role_id: this.valu,
            // department_id: this.nlist.toString(),
            userid: this.AddAdministrator.zhanghuId,
            position: this.AddAdministrator.position,
            if_leader: this.AddAdministrator.resource,
            // department_id_name: this.CheckedNodes.toString(),
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          console.log(res);
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
        })
        .catch(function (err) { });
    },
    //删除
    dele(e) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/home/admins/delSessionUser",
              qs.stringify({
                id: e,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.userTable();
            })
            .catch(function (err) { });
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
    // 修改时获取到id和手机
    bj(e, l, p, o, n, m, h, i, ed, psd, rN) {
      console.log(psd)
      this.CheckedNodes = [];
      this.modification.userid = h;
      this.nlistd = o.split(",");
      this.modification.account = ed.account;
      this.modificationid = o;
      this.modification.phone = l;
      this.modification.id = e;
      this.modification.role_id = p;
      this.modification.weixin = h;
      this.modification.weixinid = n;
      this.modification.position = m;
      this.userid_name = i;
      this.zhanghu = h;
      this.modification.psd = psd;
      this.modification.password = psd;
      this.modification.resource = ed.if_leader;
      this.modification.role_name = rN;
      if (ed.department_id_name) {
        this.CheckedNodes = ed.department_id_name;
      }
    },
    // 修改
    vak() {
      // let userObj = this.valullo.find((item) => {
      //   return item.value === this.zhanghu;
      // });
      // if (!userObj) {
      // let userObj = {
      //   userid: this.userid_name,
      // };
      // }
      let changeUser;
      if (this.AddAdministrator.zhanghuId == "") {
        changeUser = this.userid_name;
      } else {
        changeUser = this.AddAdministrator.zhanghuId;
      }
      let password = this.modification.password;
      if (password !== this.modification.psd) {
        // 如果密码进行修改再进行md5加密
        password = this.$md5(this.modification.password);
      }
      let a = "";
      a.toString(this.modification.addpassword);
      if (a !== "") {
        if (this.modification.addpassword == this.modification.password) {
          this.axios
            .post(
              "/home/admins/editSessionUser",
              qs.stringify({
                account: this.modification.account,
                phone: this.modification.phone,
                role_id: this.modification.role_id,
                id: this.modification.id,
                // department_id: this.nlistd.toString(),
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                parent_id: this.tooken.id,
                userid: changeUser,
                position: this.modification.position,
                password,
                // if_leader: this.modification.resource,
                // department_id_name: this.CheckedNodes.toString(),
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              if (res.data.code == 1) {
                this.dialogVisible = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.dialogVisible = true;
                this.$message.error(res.data.msg);
              }
              this.userTable();
            })
            .catch(function (err) { });
        } else {
          this.$message.error("密码与确认密码必须一致");
          return;
        }
      } else if (this.modification.userid == this.modification.weixin) {
        this.axios
          .post(
            "/home/admins/editSessionUser",
            qs.stringify({
              account: this.modification.account,
              phone: this.modification.phone,
              role_id: this.modification.role_id,
              id: this.modification.id,
              // department_id: this.nlistd.toString(),
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              parent_id: this.tooken.id,
              userid: changeUser,
              position: this.modification.position,
              password,
              // department_id_name: this.CheckedNodes.toString(),
            }),
            {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            if (res.data.code == 1) {
              this.dialogVisible = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.dialogVisible = true;
              this.$message.error(res.data.msg);
            }
            this.userTable();
          })
          .catch(function (err) { });
      } else {
        this.axios
          .post(
            "/home/admins/editSessionUser",
            qs.stringify({
              account: this.modification.account,
              phone: this.modification.phone,
              password,
              role_id: this.modification.role_id,
              id: this.tooken.id,
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
            }),
            {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.userTable();
          })
          .catch(function (err) { });
      }
    },
    // 页数
    handleCurrentChange(val) {
      this.axios
        .post(
          "/home/admins/getSessionUser",
          qs.stringify({
            parent_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            page: val,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    one() {
      this.duihao = this.nlist;
      this.axios
        .post(
          "/home/Department/getSessionDepartment",
          qs.stringify({
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          const arr = [];
          res.data.data.forEach((item) => {
            arr.push(item.id);
          });

          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.legeList = res.data.data;
        })
        .catch(function (err) { });
    },
    oned() {
      this.xuanran = this.nlistd;
      this.axios
        .post(
          "/home/Department/getSessionDepartment",
          qs.stringify({
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          this.legeListon = res.data.data;
          const arr = [];
          res.data.data.forEach((item) => {
            arr.push(item.id);
          });
          res.data.data.children.forEach((item) => {
            arr.push(item.id);
          });

          this.xuanran = arr;
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) { });
    },
    distribution(e) {
      this.id = e;
      this.axios
        .post(
          "/home/role/getSessionPrivilegeList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }

          this.legeList = res.data.data;
        })
        .catch(function (err) { });
      this.axios
        .post(
          "/api/role/getRolePrive",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            account_id: this.tooken.account_id,
            role_id: this.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          const arr = [];
          res.data.data.forEach((item) => {
            arr.push(item.id);
          });
          this.duihao = arr;
        })
        .catch(function (err) { });
    },
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}

.body_html {
  width: 100%;
  height: 100%;
}

.if_status {
  color: blue;
}

.tongg {
  color: red;
}

.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
  padding: 23px 31px;
  overflow: hidden;
  overflow-y: auto;
}

.tianjia {
  width: 100%;
  height: 100%;
}

.tianjia>main {
  font-size: 26px;
}

.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
}

.set-popper {
  width: 50rem;
}

.set-content {
  cursor: default;
  width: 100%;
  overflow: hidden;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

